import styled from 'styled-components';
import Form from '../../Form/Form';

export const StyledRenameChatModal = styled(Form)`
  width: 100%;
  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;
